export enum RoutingEnum {
  homepage = '',
  Energia = 'lithium',
  Step1 = 'personalizza',
  Confirm = 'conferma',
  Summary = 'riepilogo',
  // Contacts = 'contatti',
  ConfirmBuy = 'conferma-acquisto',
  ConfirmQuotation = 'conferma-quotazione',
  AlreadyInsured = 'gia-assicurata',
  QuotationError = 'errore-quotazione',
  PaymentError = 'errore-pagamento',
  GenericError = 'errore',
  Disservice = 'disservizio',
  /*TODO
  - salvataggio-quotazione (scadenza > 60g)
  - salva-preventivo (scadenza < 60g se NON acquisto)
  */
  Thankyou = 'grazie',
  ThankyouQuotation = 'salvataggio-quotazione',
  ThankyouEstimation = 'salva-preventivo',
  AllianzPay = 'allianzpay',
  AllianzPaySummary = 'allianzpay/riepilogo',
  AllianzPayPaymentOk = 'allianzpay/polizza-acquistata',
  AllianzPayPaymentError = 'allianzpay/errore-pagamento',
  AllianzPayGenericError = 'allianzpay/errore',
  AllianzPayInvalidCodeError = 'allianzpay/codice-scaduto',
  NotFound = '**',
  ecommerce = 'eCommerce/quotazione',
  Payment = 'polizza-acquistata',
}

export const OldRoutes: Record<string, RoutingEnum> = {
  allianzpay: RoutingEnum.AllianzPay,
  quotationerror: RoutingEnum.QuotationError,
  configure: RoutingEnum.Step1,
  summary: RoutingEnum.Summary,
  result: RoutingEnum.Payment,
  'data/': RoutingEnum.Confirm,
};
